import React, { useEffect, useContext } from "react";
import styles from './treino.module.css';
import { Link, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchPlanoList } from "../../redux/planos/slices";
import { finalizarTreino } from "../../redux/treinos/slices";
import { fetchProgresso, carregarRegistrosUsuario } from "../../redux/progresso/slices";
import OffCanvasNavBar from "../../components/OffCanvasNavBar";
import FooterButton from "../../components/FooterButton";
import Button from "../../components/Button";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "../../components/Spinner";
import TreinoCard from "./components/treino-card";
import { getErrorMessage } from "../../utils/helpers";

export default function Treino() {
  const dispatch = useDispatch();

  const planos = useSelector(state => state.planosReducer.planos);
  const loadingTreino = useSelector(state => state.planosReducer.loading);

  const historico = useSelector(state => state.progressoReducer.historico);
  const registrosUsuario = useSelector(state => state.progressoReducer.registrosUsuario);
  const loadingProgresso = useSelector(state => state.progressoReducer.loading);
  const progressoLoaded = useSelector(state => state.progressoReducer.loaded);
  const { showAlert } = useContext(AlertContext);

  const loading = loadingTreino || loadingProgresso;

  useEffect(() => {
    dispatch(fetchPlanoList());

    dispatch(fetchProgresso());

    dispatch(carregarRegistrosUsuario());

  }, []);

  const handleFinalizar = async () => {
    try {
      await dispatch(finalizarTreino());
      showAlert("Parabéns! Treino Concluido!", 'success');
    } catch (err) {
      console.log("Erro ao finalizar treino:", err);
      showAlert(getErrorMessage(err, "Erro ao finalizar treino. Tente novamente."), 'error');
    }
  };

  const planoAtivo = planos?.find(p => p.ativo);

  if (loading) {
    return (
      <div className={styles.mainContainer}>
        <Spinner className="vh-100" />
      </div>
    );
  }

  if (!planoAtivo) {
    return (
      <>
        <OffCanvasNavBar />
        <div className={styles.noPlanContainer}>
          <p className={styles.noPlanMessage}>Parece que você ainda não selecionou um plano de treino.</p>
          <p className={styles.noPlanSubMessage}>Para acessar a biblioteca de treinos:</p>
          <Button link="/biblioteca-treino" title="Clique Aqui"></Button>
        </div >
      </>
    );
  }

  const rotinaHoje = planoAtivo.rotina
    ? planoAtivo.rotina.find(treino => treino.ativo === true) || planoAtivo.rotina[0]
    : null;

  return (
    <>
      <OffCanvasNavBar />
      <main className={styles.mainContainer}>
        <Link to='/select-treino' className={styles.progressCard}>
          <div className={styles.progressHeader}>
            <div>
              <h2 className={styles.progressTitle}>{planoAtivo.titulo}</h2>
              <p className={styles.progressSubtitle}>Hoje: {rotinaHoje?.foco}</p>
            </div>
            <div className={styles.progressBadge}>
              <span className={styles.badgeText}>{rotinaHoje?.dia}</span>
            </div>
          </div>
          {(() => {
            const dataAtual = new Date().toISOString().split('T')[0];
            const totalExercicios = rotinaHoje?.exercicios?.length || 0;
            const concluidos = totalExercicios > 0
              ? rotinaHoje.exercicios.filter(ex =>
                registrosUsuario?.some(r =>
                  String(r.exercicioId) === String(ex.id) &&
                  r.data === dataAtual &&
                  r.dia === rotinaHoje.dia &&
                  r.idPlano === planoAtivo.id &&
                  r.finalizado === false &&
                  r.concluido
                )
              ).length
              : 0;
            const porcentagem = totalExercicios > 0 ? Math.round((concluidos / totalExercicios) * 100) : 0;
            return (
              <>
                <div className={styles.progressStats}>
                  <span>{concluidos}/{totalExercicios} exercícios</span>
                  <span>{porcentagem}%</span>
                </div>
                <div className={styles.progressBarBg}>
                  <div className={styles.progressBarFill} style={{ width: `${porcentagem}%` }}></div>
                </div>
              </>
            );
          })()}
        </Link>

        <Link to='/biblioteca-treino' className={styles.planCard}>
          <div className={styles.planContent}>
            <div>
              <p className={styles.planLabel}>Plano Ativo</p>
              <p className={styles.planName}>{planoAtivo.titulo}</p>
            </div>
            <div className={styles.planTag}>
              {planoAtivo.nivel || "Iniciante"}
            </div>
          </div>
        </Link>

        {rotinaHoje ? (
          <TreinoCard rotina={rotinaHoje} idPlano={planoAtivo?.id} />
        ) : (
          <p>Nenhum exercício encontrado para hoje.</p>
        )}
        <FooterButton title="Finalizar Treino" onClick={handleFinalizar}></FooterButton>
      </main>
    </>
  );
}